<template>
    <div ref="impresspage" class="impress-page">
        <div class="impress-content">
            <h2 class="text-muted kursiv">
                <TerminalSimulator 
                referrer="impresspage.head"
                text="Impressum" 
                :isWritten="pageLoadingStore.isLoaded('impresspage.head')" 
                @textIsWritten="pageLoadingStore.setLoaded('impresspage.head',true)"
            />
            </h2>
            <br>
            <br>
            <TerminalSimulator 
                referrer="impresspage"
                text="
                    <h2>Angaben gem&auml;&szlig; &sect; 5 TMG</h2><br>
                    <hr><br>
                    Azad Barkho<br>
                    Krigerstra&szlig;e 41<br>
                    45479 Mülheim an der Ruhr
                    <br>
                    <br>
                
                    <h2>Kontakt</h2><br>
                    <hr><br>
                    Nutzen Sie bitte die Möglichkeit mich mit dem <a href='/contact' style='color:lightgreen'>Kontaktformular</a> zu kontaktieren.
                    
                    <br>
                    <p>Quelle: <a href='https://www.e-recht24.de' target='_blank'>eRecht24</a></p>
                " 
                :isWritten="pageLoadingStore.isLoaded('impresspage')" 
                @textIsWritten="pageLoadingStore.setLoaded('impresspage',true)"
            />
        </div>
    </div>
</template>

<script>
    import TerminalSimulator from '../components/TerminalSimulator.vue';
    import { usePageLoadingStore } from '../stores/pageLoadingStore.js';

    export default {
        __name: 'ImpressPage',
        data() {

        },
        setup(){
            const pageLoadingStore = usePageLoadingStore();
            return {
                pageLoadingStore
            }
        },
        components:{
            TerminalSimulator
        }
    }
</script>

<style scoped>
.text-muted{
    color: white !important;
    font-size: x-large;
    font-weight: bolder;
    text-align: center;
    width: 100%;
}

.impress-page{
    color: rgb(255, 255, 255);
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-weight: bolder;
    font-family: orbitron;
    font-size: v-bind(size+"px");
    position: absolute;
    top: 50%;
    bottom: 50%;
    position: relative;
}
</style>
<style>
.impress-content {
    display: inline-block !important;
    background-color: #00000069;
    font-size: large;
}

.impress-content h1 {
    font-size: xx-large;
    max-width: 90%;
    text-align: center;
    background-color: #00000069;
}

.impress-content h2 {
    display: inline-block;
}

</style>